export default {
  lang: 'tw',
}